import qs from 'qs';

enum SORT_TYPES {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DESC = 'TITLE_DESC',
}

export const sortOptions = [
  { value: SORT_TYPES.NEWEST, label: 'Newest' },
  { value: SORT_TYPES.OLDEST, label: 'Oldest' },
  { value: SORT_TYPES.TITLE_ASC, label: 'Title Asc' },
  { value: SORT_TYPES.TITLE_DESC, label: 'Title Desc' },
];

export const getSortingValue = (search: string) => {
  const query = qs.parse(search.replace(/^\?/, ''));

  if (!query.sortBy || query.sortBy === 'publishDate') {
    return query.sortOrder !== 'ASC' ? SORT_TYPES.NEWEST : SORT_TYPES.OLDEST;
  }
  return query.sortOrder !== 'DESC'
    ? SORT_TYPES.TITLE_ASC
    : SORT_TYPES.TITLE_DESC;
};

export const extendSearch = (search: string, sort?: string) => {
  let query = qs.parse(search.replace(/^\?/, ''));

  switch (sort) {
    case SORT_TYPES.NEWEST:
      query = {
        ...query,
        sortBy: 'publishDate',
        sortOrder: 'DESC',
      };
      break;
    case SORT_TYPES.OLDEST:
      query = {
        ...query,
        sortBy: 'publishDate',
        sortOrder: 'ASC',
      };
      break;
    case SORT_TYPES.TITLE_ASC:
      query = {
        ...query,
        sortBy: 'title',
        sortOrder: 'ASC',
      };
      break;
    case SORT_TYPES.TITLE_DESC:
      query = {
        ...query,
        sortBy: 'title',
        sortOrder: 'DESC',
      };
      break;
    default:
      query = {
        ...query,
        sortBy: 'publishDate',
        sortOrder: 'DESC',
      };
      break;
  }

  const result = qs.stringify(query);

  return result ? `?${result}` : '';
};
